import { render } from "./AllocatePrescriptionTab.vue?vue&type=template&id=b40427e8&scoped=true"
import script from "./AllocatePrescriptionTab.vue?vue&type=script&lang=js"
export * from "./AllocatePrescriptionTab.vue?vue&type=script&lang=js"

import "./AllocatePrescriptionTab.vue?vue&type=style&index=0&id=b40427e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40427e8"]])

export default __exports__